import React, {FC, useEffect, useRef, useState} from "react";
import './contentViewer.scss';
import {Modal} from "antd";
import closeIcon from "../../../../assets/icons/close.svg";
import ToggleSwitch from "../../ToggleSwitch";
import PdfViewer from "../../PDFViewer";
import VideoViewer from "../../VideoViewer";

interface ChapterContentViewerProps{
    visible: boolean;
    setVisible: Function;
    content: any;
    handleStatusToggle: Function;
}

const ChapterContentViewer:FC<ChapterContentViewerProps> = (props) => {

    const {visible, setVisible, content, handleStatusToggle} = props;

    const [sourceUrl,setSourceUrl] = useState<any>(null);

    const playerRef = useRef<any>();

    useEffect(()=>{
        setSourceUrl(content?.contentLibrary?.s3AttachmentUrl);
    },[content])

    useEffect(()=>{
        let playerState = playerRef?.current?.getState().player;
        if(playerState?.currentSrc && !visible) {
            playerRef?.current?.pause();
            setSourceUrl(null);
            playerState.currentSrc = null;
            playerRef?.current.load();
        }
    },[visible]);

    return(
        <Modal title={null}
               centered
               visible={visible}
               onCancel={()=>setVisible(false)}
               footer={null}
               className='board-form__modal video-content__modal'
               closeIcon={<img src={closeIcon} alt=''/>}
        >
            <div className='board-form__header'>
                <div className='board-form__title'>{content?.displayTitle || content?.title}</div>
            </div>
            <div className='video-content__details'>
                <div className='video-content__info'>
                    {content?.contentLibrary?.contentLength} {content?.contentLibrary?.contentType === 'video' ? ' mins': ' pages'}
                    {/*<span className="details-separator"/> Trigonometry
                    <span className="details-separator"/> Mathematics*/}
                </div>
                <div className='board-form__toggle'>
                    <ToggleSwitch checked={content?.isActive}
                                  handleChange={(checked) => {
                                      handleStatusToggle(checked)
                                  }}
                    />
                </div>
            </div>
            {content?.contentLibrary?.contentType === 'video' &&
                <VideoViewer playerRef={playerRef} fileUrl={sourceUrl}/>
            }
            {content?.contentLibrary?.contentType === 'pdf' &&
                <PdfViewer fileUrl={sourceUrl}/>
            }
        </Modal>
    )
}

export default ChapterContentViewer;
